export default "__VITE_ASSET__0IWz3CAt__"